import API from './API';

export default class Cinema extends API {

  static lista() {
    return super.get(`/ws/cinema/lista/filmes`);
  }

  static filme(id) {
    return super.get(`/ws/cinema/filme/${id}`);
  }

  static lista_full() {
    return super.get(`/ws/cinema`);
  }

}



// WEBPACK FOOTER //
// ./src/services/api/Cinema.js